// #518: Ordnerauswahl in „Zur Ablage“ – Gruppierung nach Hauptordner und Suche (reine Funktionen).

export interface OrdnerOption { pfad: string; name: string; tiefe: number }

export interface OrdnerGruppe { haupt: OrdnerOption; unter: OrdnerOption[] }

/** Flache Liste (tiefe 0 = Hauptordner) in Gruppen je Hauptordner; Einträge vor dem ersten Hauptordner bilden eigene Gruppen. */
export function gruppiereOrdner(optionen: readonly OrdnerOption[]): OrdnerGruppe[] {
  const gruppen: OrdnerGruppe[] = [];
  for (const o of optionen) {
    if (o.tiefe === 0 || gruppen.length === 0) gruppen.push({ haupt: o, unter: [] });
    else gruppen[gruppen.length - 1]!.unter.push(o);
  }
  return gruppen;
}

const norm = (s: string) => s.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');

/** Treffer für die Suche: alle Ordner, deren Name oder Pfad alle Suchwörter enthält (Umlaute egal). */
export function sucheOrdner(optionen: readonly OrdnerOption[], suche: string): OrdnerOption[] {
  const woerter = norm(suche).split(/\s+/).filter(Boolean);
  if (!woerter.length) return [...optionen];
  return optionen.filter(o => { const t = norm(`${o.pfad} ${o.name}`); return woerter.every(w => t.includes(w)); });
}

/** „01 Verwaltung/Eigentümer/WE01“ → „01 Verwaltung › Eigentümer › WE01“. */
export function pfadAnzeige(pfad: string): string {
  return pfad.split('/').map(t => t.trim()).filter(Boolean).join(' › ');
}

/** Übergeordneter Pfad zur Orientierung in der Trefferliste („01 Verwaltung › Eigentümer“), leer bei Hauptordnern. */
export function elternPfad(pfad: string): string {
  const teile = pfad.split('/').map(t => t.trim()).filter(Boolean);
  return teile.slice(0, -1).join(' › ');
}
